module.exports = __webpack_public_path__ + "static/media/15.220034a8.jpg";